var _rect, _rect2, _g, _line, _line2, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 140,
    viewBox: "0 0 420 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 400,
    height: 120,
    rx: 10,
    stroke: "#ff6b35",
    strokeWidth: 4,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 50,
    width: 380,
    height: 70,
    rx: 5,
    stroke: "#ff6b35",
    strokeWidth: 2,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 60)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 20,
    stroke: "#ff6b35",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 8,
    fill: "#282c34"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 3,
    fill: "#ff6b35"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 5,
    x2: 25,
    y2: 17,
    stroke: "#ff6b35",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 33,
    x2: 25,
    y2: 45,
    stroke: "#ff6b35",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 25,
    x2: 17,
    y2: 25,
    stroke: "#ff6b35",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 25,
    x2: 45,
    y2: 25,
    stroke: "#ff6b35",
    strokeWidth: 2
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 85,
    x2: 140,
    y2: 85,
    stroke: "#ff6b35",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 85,
    x2: 190,
    y2: 85,
    stroke: "#ff6b35",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 75,
    fontFamily: "Arial, sans-serif",
    fontSize: 32,
    fontWeight: "bold",
    fill: "#282c34"
  }, "\n    way\n    ", /*#__PURE__*/React.createElement("tspan", {
    fill: "#ff6b35"
  }, "motor"), /*#__PURE__*/React.createElement("tspan", {
    fontSize: 24
  }, ".ru"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.69fc8e2c196faec5e23da867f9759f6b.svg";
export { ForwardRef as ReactComponent };